var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSummaryFlag = function SvgIconSummaryFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.271 33.09V6.91a.727.727 0 0 0-.727-.727H9.09a.727.727 0 0 0-.728.727V33.09c0 .401.326.727.728.727h1.454a.727.727 0 0 0 .727-.727Z",
    fill: "#CA7300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.637 12h7.272c.402 0 .728.325.728.727v13.819a.727.727 0 0 1-.728.727h-7.272V12Z",
    fill: "#FFAD24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.271 8.363h-16v15.273h16V8.363Z",
    fill: "#FFC82A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.637 27.272 3.636-3.636h-3.636v3.636Z",
    fill: "#CA7300"
  })));
};
export default SvgIconSummaryFlag;